import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AlertService, NotificationService } from '@app/core';
import { PostItem } from '@app/core/models';
import { DailyService } from '@app/core/services';
import { SHARED_MODULES, SwitchComponent } from '@app/shared';
import { notNull, safeEmpty } from '@app/shared/utils';
import { of, tap } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { LoaderFn } from '../item-post/item-post.component';

@Component({
  imports: [SHARED_MODULES],
  templateUrl: './extra-daily.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExtraDailyComponent {
  public readonly item = input<PostItem>();
  public readonly loaderFn = input<LoaderFn>();
  public readonly actionFn = input<any>();
  private readonly _alertService = inject(AlertService);
  private readonly _dailyService = inject(DailyService);
  private readonly _notificationService = inject(NotificationService);

  public onToggle(status: boolean, component: SwitchComponent) {
    const loader = this.loaderFn();
    const dimissFn = () => (component.checked = !status);
    loader(() => {
      const message = status ? 'eclass.deseja-publicar' : 'eclass.deseja-despublicar';
      return this.observable(message, status, this.item(), dimissFn);
    });
  }

  public observable(message: string, published: boolean, item: PostItem, dimissFn: () => void) {
    return this._alertService.confirm({ message }).pipe(
      tap((confirm) => !confirm && dimissFn()),
      notNull(),
      switchMap(() =>
        this._dailyService.changeStatus(item.reference_id, { published: Number(published) }).pipe(
          catchError(() => {
            dimissFn();
            return of({ ret: 0, data: null });
          }),
          safeEmpty(),
        ),
      ),
      tap((res) => {
        if (!!res) {
          this._notificationService.success('geral.sucesso');
        } else {
          this._notificationService.error('geral.erro');
        }
      }),
    );
  }
}
